import React from 'react';

import useUserData from 'data-hooks/useUserData';

// This HOC can be used to pass the user object into legacy class components
// that have not yet been converted to function components
const withUser = ComponentToWrap => {
  const WithUser = props => {
    const { data: userData } = useUserData();
    const user = userData?.user;

    WithUser.displayName = `withUser(${ComponentToWrap.displayName ||
      ComponentToWrap.name})`;

    return <ComponentToWrap {...props} user={user} />;
  };

  return WithUser;
};

export default withUser;
